import Contract from "app/models/contract"
import { Action, Types } from "./contracts.actions"

export type ContractsState = {
  data: Contract[]
  errors: {}
  loading: boolean
}

const initialState: ContractsState = {
  data: [],
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): ContractsState => {
  switch (action.type) {
    case Types.POST:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.GET_BY_ID:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data || [],
      }

    case Types.GET_BY_ID_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
